/* Alpha Elements theme — interactions (vanilla JS, no dependencies).
   Cart = Shopify Ajax Cart API (/cart.js, /cart/add.js, /cart/change.js). Chat answers ONLY from verified product facts. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S = window.AE_SETTINGS || {};
  const R = S.routes || { cartJs: '/cart.js', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart', root: '/' };
  const track = (e, p) => window.AE?.track?.(e, p || {});

  /* ---------- money (Shopify money_format) ---------- */
  function money(cents) {
    const fmt = S.moneyFormat || '€{{amount_with_comma_separator}}';
    const n = (Number(cents) || 0) / 100;
    const group = (v, d, ts, ds) => { const [i, f] = v.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ',', '.'), amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','), amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
      amount_with_apostrophe_separator: group(n, 2, "'", '.'), amount_with_space_separator: group(n, 2, ' ', ','),
    }[k] ?? group(n, 2, '.', ',')));
  }
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- cart ---------- */
  let cart = null;
  const json = r => r.ok ? r.json() : r.json().then(j => Promise.reject(j));
  const getCart = () => fetch(R.cartJs, { headers: { Accept: 'application/json' } }).then(json).then(c => (cart = c));
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);

  function renderCart() {
    if (!cart) return;
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const body = $('#cart-body'), foot = $('#cart-foot');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><p>Dein Warenkorb ist leer.</p><a class="btn btn--ghost" href="${esc(R.root)}">Weiter einkaufen</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    const t = cart.total_price, thr = S.freeShippingCents || 0, left = Math.max(0, thr - t);
    const ship = thr ? (left > 0 ? `Noch <strong>${money(left)}</strong> bis zum kostenlosen Versand in Österreich.` : `<strong>Kostenloser Versand</strong> in Österreich ist freigeschaltet.`) : '';
    const one = cart.items.length === 1 ? cart.items[0] : null;
    const bq = S.bundleQty || 3, bd = S.bundleDiscount || 0;
    const upsell = (bd > 0 && one && one.quantity === 1 && !one.selling_plan_allocation)
      ? `<div class="upsell"><span><b>${bq * 30}-Tage-Vorrat:</b> ${bq} Dosen mit ${bd} % Rabatt – du sparst ${money(Math.round(one.final_price * bq * bd / 100))}.</span><button class="btn btn--ghost" style="min-height:40px;padding:0 16px" data-set-qty="${esc(one.key)}:${bq}">Auf ${bq} wechseln</button></div>` : '';
    body.innerHTML = (ship ? `<div class="ship-bar">${ship}<div class="track"><i style="width:${Math.min(100, t / thr * 100)}%"></i></div></div>` : '') +
      cart.items.map(i => {
        const plan = i.selling_plan_allocation ? `<div class="tiny muted">${esc(i.selling_plan_allocation.selling_plan.name)}</div>` : '';
        const variant = i.variant_title && i.variant_title !== 'Default Title' ? `<div class="tiny muted">${esc(i.variant_title)}</div>` : '';
        const img = i.image ? `<img src="${esc(i.image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2'))}" alt="" width="72" height="72" loading="lazy">` : '<span></span>';
        const was = i.original_line_price > i.final_line_price ? `<s class="tiny muted">${money(i.original_line_price)}</s><br>` : '';
        return `<div class="line">${img}<div><a href="${esc(i.url)}"><b>${esc(i.product_title)}</b></a>${variant}${plan}
          <div class="qty" role="group" aria-label="Menge ${esc(i.product_title)}"><button data-set-qty="${esc(i.key)}:${i.quantity - 1}" aria-label="Weniger">−</button><span>${i.quantity}</span><button data-set-qty="${esc(i.key)}:${i.quantity + 1}" aria-label="Mehr">+</button></div></div>
          <div class="num" style="text-align:right">${was}<b>${money(i.final_line_price)}</b></div></div>`;
      }).join('') + upsell + (cart.cart_level_discount_applications?.length ? `<p class="tiny muted">Rabatt: ${cart.cart_level_discount_applications.map(d => esc(d.title)).join(', ')}</p>` : '');
    const tot = $('#cart-total'); if (tot) tot.textContent = money(t);
  }
  const refresh = () => getCart().then(renderCart).catch(() => {});

  /* ---------- panels ---------- */
  const overlay = $('#overlay');
  let lastFocus = null;
  function openPanel(el) { if (!el) return; lastFocus = document.activeElement; el.classList.add('is-open'); overlay?.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(() => el.querySelector('button,a,input')?.focus(), 60); }
  function closePanels() { $$('.drawer.is-open,.mobile-nav.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; lastFocus?.focus?.(); }
  function openDrawer() { openPanel($('#cart')); refresh(); track('view_cart', { items: cart?.item_count }); }
  overlay?.addEventListener('click', closePanels);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closePanels(); closeChat(); } });
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const shown = el => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const modal = $$('[aria-modal="true"]').reverse().find(m => !m.hidden && m.getAttribute('aria-hidden') !== 'true' && shown(m));
    if (!modal) return;
    const f = $$(FOCUSABLE, modal).filter(shown); if (!f.length) return;
    const i = f.indexOf(document.activeElement); e.preventDefault();
    (i < 0 ? f[e.shiftKey ? f.length - 1 : 0] : f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length]).focus();
  });

  /* ---------- add to cart (product form with purchase options) ---------- */
  function syncPlan(form) {
    const sel = form.querySelector('.options input[type=radio]:checked'); if (!sel) return;
    const group = sel.name;
    $$(`[data-plan-price="${group}"]`).forEach(el => el.textContent = money(sel.dataset.price));
    $$(`[data-plan-label="${group}"]`).forEach(el => el.textContent = sel.dataset.label || '');
    const qty = form.querySelector('[data-qty-input]'); if (qty) qty.value = sel.dataset.qty || 1;
    const sp = form.querySelector('[data-selling-plan-input]'); if (sp) sp.disabled = !sel.dataset.sellingPlan;
  }
  $$('form[data-product-form]').forEach(form => {
    form.addEventListener('change', e => { if (e.target.matches('.options input')) { syncPlan(form); track('select_plan', { option: e.target.value }); } });
    syncPlan(form);
    form.addEventListener('submit', e => {
      e.preventDefault();
      const sel = form.querySelector('.options input:checked');
      const item = { id: Number(form.querySelector('[name=id]').value), quantity: Number(sel?.dataset.qty || 1) };
      if (sel?.dataset.sellingPlan) item.selling_plan = Number(sel.dataset.sellingPlan);
      const btn = form.querySelector('[type=submit]'), err = form.querySelector('[data-form-error]');
      btn?.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      post(R.cartAdd, { items: [item] })
        .then(() => { track('add_to_cart', { option: sel?.value, quantity: item.quantity }); return refresh(); })
        .then(() => openDrawer())
        .catch(j => { if (err) { err.textContent = j?.description || j?.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.'; err.hidden = false; } })
        .finally(() => btn?.removeAttribute('aria-busy'));
    });
  });

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open-cart],[data-close],[data-set-qty],[data-open-menu],[data-open-chat],[data-tab],[data-thumb],[data-sticky-add]');
    if (!t) return;
    if (t.matches('[data-open-cart]')) { e.preventDefault(); openDrawer(); }
    else if (t.matches('[data-close]')) closePanels();
    else if (t.matches('[data-open-menu]')) openPanel($('#mobile-nav'));
    else if (t.matches('[data-open-chat]')) { e.preventDefault(); openChat(); }
    else if (t.matches('[data-set-qty]')) {
      // line keys look like "variantId:hash" – the quantity is everything after the LAST colon
      const v = t.dataset.setQty, cut = v.lastIndexOf(':'), key = v.slice(0, cut), q = Math.max(0, parseInt(v.slice(cut + 1), 10) || 0);
      t.disabled = true;
      post(R.cartChange, { id: key, quantity: q }).then(c => { cart = c; renderCart(); }).catch(refresh);
    }
    else if (t.matches('[data-sticky-add]')) { e.preventDefault(); const f = $(`#${t.dataset.stickyAdd}`); f?.requestSubmit ? f.requestSubmit() : f?.submit(); }
    else if (t.matches('[data-tab]')) selectTab(t);
    else if (t.matches('[data-thumb]')) selectThumb(t);
  });
  $('#checkout')?.addEventListener('click', () => track('begin_checkout', { items: cart?.item_count }));

  /* ---------- tabs ---------- */
  function selectTab(btn) {
    const list = btn.closest('[role="tablist"]');
    $$('[role="tab"]', list).forEach(b => { const on = b === btn; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; const p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on; });
  }
  $$('[role="tablist"]').forEach(list => list.addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
    const tabs = $$('[role="tab"]', list), i = tabs.indexOf(document.activeElement);
    const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); selectTab(n);
  }));

  /* ---------- gallery ---------- */
  function selectThumb(btn) {
    const main = $('#gallery-main'); if (!main) return;
    main.src = btn.dataset.thumb; main.srcset = btn.dataset.srcset || ''; main.alt = btn.querySelector('img')?.alt || '';
    $$('[data-thumb]').forEach(b => b.setAttribute('aria-current', b === btn));
  }

  /* ---------- header, sticky ATC, reveal, toc ---------- */
  const header = $('.header');
  addEventListener('scroll', () => header?.classList.toggle('is-scrolled', scrollY > 8), { passive: true });
  const buy = $('#buy'), sticky = $('.sticky-atc'), footer = $('.footer');
  if (buy && sticky && 'IntersectionObserver' in window) {
    let buyVisible = true, footVisible = false;
    const upd = () => { const on = !buyVisible && !footVisible && buy.getBoundingClientRect().top < 0; sticky.classList.toggle('is-visible', on); document.body.classList.toggle('has-sticky', on); };
    new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting; upd(); }).observe(buy);
    if (footer) new IntersectionObserver(([e]) => { footVisible = e.isIntersecting; upd(); }).observe(footer);
  }
  // reveal on scroll; in the theme editor everything is shown at once and re-rendered sections are picked up again
  const io = 'IntersectionObserver' in window && !window.Shopify?.designMode
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  const reveal = (root = document) => $$('.reveal', root).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  reveal();
  document.addEventListener('shopify:section:load', e => reveal(e.target));
  const toc = $('[data-toc]');
  if (toc) {
    const mq = matchMedia('(max-width: 980px)'); if (mq.matches) toc.open = false;
    toc.addEventListener('click', e => { if (e.target.closest('a') && mq.matches) toc.open = false; });
  }

  /* ---------- newsletter (Shopify customer form): consent checkbox required before submit ---------- */
  $$('form[data-newsletter]').forEach(f => f.addEventListener('submit', e => {
    const box = f.querySelector('input[type=checkbox]'), msg = f.querySelector('[data-msg]');
    if (box && !box.checked) { e.preventDefault(); if (msg) msg.textContent = 'Bitte stimme der Zusendung des Newsletters zu.'; return; }
    track('sign_up', { method: 'newsletter' });
  }));

  /* ---------- product adviser: site-bot engine + chat/src/adviser.js (assets/ae-chat-core.js, data: assets/ae-chat-data.js,
     both generated by chat/build.mjs). Answers only from verified facts; medical questions → doctor + staff.
     Links/prices come from the #chat data attributes (Shopify URLs, live prices). Under every answer: 1–3 chips + buy/contact. ---------- */
  const chat = $('#chat'), log = $('#chat-log');
  const D = chat?.dataset || {};
  const cents = v => { const n = parseInt(v, 10); return n > 0 ? n : 0; };
  const PRODUCT = D.product || '/products/all-in-one', CONTACT = D.contact || '/pages/contact';
  const botOpts = {
    email: D.email || S.supportEmail || '',
    links: {
      'produkt.html': PRODUCT, 'inhaltsstoffe.html': D.ingredients || '/pages/inhaltsstoffe', 'faq.html': D.faq || '/pages/faq',
      'kontakt.html': CONTACT, 'widerruf.html': D.widerruf || '/pages/widerruf', 'versand.html': D.shipping || '/policies/shipping-policy',
      'qualitaet.html': D.quality || '/pages/qualitaet', 'ueber-uns.html': D.about || '/pages/ueber-uns', 'agb.html': D.terms || '/policies/terms-of-service',
      'datenschutz.html': D.privacy || '/policies/privacy-policy', 'impressum.html': D.imprint || '/policies/legal-notice', konto: D.account || '/account',
    },
    prices: { once: cents(D.priceCents), sub: cents(D.subCents), bundle: cents(D.bundleCents) },
  };
  // engine + data (~310 KB) load only when the chat is used (hover/focus on the launcher or first open) – keeps every page light
  let bot = null, botP = null;
  const loadJs = src => new Promise((ok, no) => { if (!src) return no(); const t = document.createElement('script'); t.src = src; t.onload = ok; t.onerror = no; document.head.appendChild(t); });
  const ensureBot = () => botP || (botP = (window.AEChat && window.AE_CHAT_DATA ? Promise.resolve() : loadJs(chat?.dataset.coreSrc).then(() => loadJs(chat?.dataset.dataSrc)))
    .then(() => { bot = window.AEChat && window.AE_CHAT_DATA ? window.AEChat.create(window.AE_CHAT_DATA, botOpts) : null; }, () => { bot = null; }));
  ['pointerenter', 'focus', 'touchstart'].forEach(ev => $('.chat-launch')?.addEventListener(ev, ensureBot, { once: true, passive: true }));
  const onProduct = () => document.body.classList.contains('template-product') && !!$('#buy');
  function push(html, who) { const d = document.createElement('div'); d.className = 'msg msg--' + who; d.innerHTML = html; log.appendChild(d); log.scrollTop = log.scrollHeight; return d; }
  function extras(list) {
    if (list?.length) { const c = document.createElement('div'); c.className = 'chips'; list.slice(0, 3).forEach(x => { const b = document.createElement('button'); b.type = 'button'; b.textContent = x; b.onclick = () => ask(x); c.appendChild(b); }); log.appendChild(c); }
    const a = document.createElement('div'); a.className = 'chat-actions';
    a.innerHTML = `<a class="btn btn--brass" href="${esc(PRODUCT)}#buy" data-chat-buy>ALL-IN-ONE kaufen</a><a class="btn btn--ghost" href="${esc(CONTACT)}#formular">Mitarbeiter fragen</a>`;
    log.appendChild(a); log.scrollTop = log.scrollHeight;
  }
  function say(r) { push(r.html + (r.link ? ` <a class="chat-more" href="${esc(r.link)}">${esc(r.linkLabel || 'Mehr dazu')} →</a>` : ''), 'bot'); extras(r.chips); }
  /* KI-Fallback: only when the rule-based adviser did not understand (never for medical topics) – Cloudflare Workers AI, free daily quota */
  const AI_URL = $('#chat')?.dataset.ai || '', conv = [];
  const mdAI = t => esc(t).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>').replace(/\n/g, '<br>');
  function askAI(q, r) {
    const wait = push('<span class="chat-typing" aria-label="Antwort wird geschrieben"><i></i><i></i><i></i></span>', 'bot');
    const ctl = new AbortController(), to = setTimeout(() => ctl.abort(), 15000);
    fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ q, history: conv.slice(-6) }), signal: ctl.signal })
      .then(res => res.json()).catch(() => ({})).then(d => {
        clearTimeout(to); wait.remove();
        if (d.answer) { track('chat_question', { topic: 'ki' }); conv.push({ role: 'user', content: q }, { role: 'assistant', content: d.answer }); push(mdAI(d.answer), 'bot'); extras(r.chips); return; }
        if (d.error === 'medical') { push('Bei persönlichen Gesundheitsfragen lass dich bitte ärztlich beraten – bei Fragen zum Produkt kümmert sich ein Mitarbeiter darum.', 'bot'); extras(r.chips); return; }
        track('chat_question', { topic: r.id }); say(r);
      });
  }
  function ask(q) {
    if (!q.trim()) return;
    log.querySelectorAll('.chips,.chat-actions').forEach(n => n.remove());   // buttons only under the newest answer
    push(esc(q), 'me');
    ensureBot().then(() => {
      if (!bot) { const m = D.email || S.supportEmail || ''; push(`Der Produktberater ist gerade nicht verfügbar. Schreib uns an <a href="mailto:${esc(m)}">${esc(m)}</a> – ein Mitarbeiter kümmert sich darum.`, 'bot'); extras([]); return; }
      const r = bot.ask(q);
      if (AI_URL && !r.safety && (r.id === 'unklar' || (conv.length && /\b(davon|dazu|damit|darin|daran|dafür|dabei)\b/i.test(q)))) return askAI(q, r);
      conv.push({ role: 'user', content: q }, { role: 'assistant', content: r.text });
      track('chat_question', { topic: r.id });
      say(r);
    });
  }
  function openChat() {
    if (!chat) return; chat.classList.add('is-open'); track('chat_open'); $('.chat-launch')?.setAttribute('aria-expanded', 'true');
    if (!log.children.length) ensureBot().then(() => { if (log.children.length) return; const g = bot ? bot.greeting() : { html: 'Hallo, ich bin der Produktberater von Alpha Elements.', chips: [] }; push(g.html, 'bot'); extras(g.chips); });
    setTimeout(() => $('#chat-input')?.focus(), 80);
  }
  function closeChat() { chat?.classList.remove('is-open'); $('.chat-launch')?.setAttribute('aria-expanded', 'false'); }
  log?.addEventListener('click', e => {   // on the product page the buy button scrolls to the buy box instead of reloading
    if (!e.target.closest('[data-chat-buy]') || !onProduct()) return;
    e.preventDefault(); closeChat(); $('#buy').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  $('#chat-close')?.addEventListener('click', closeChat);
  $('#chat-form')?.addEventListener('submit', e => { e.preventDefault(); const i = $('#chat-input'); ask(i.value); i.value = ''; });

  /* ---------- gold press ring on ghost buttons ---------- */
  document.addEventListener('click', e => { const b = e.target.closest('.btn--ghost'); if (!b) return; b.classList.remove('is-pressed'); void b.offsetWidth; b.classList.add('is-pressed'); setTimeout(() => b.classList.remove('is-pressed'), 900); });

  refresh();
})();
